import React from "react";
import styled from 'styled-components'
import Container from '@material-ui/core/Container';
import {H4, StyledInput, StyledButton, StyledError} from "../../../../component/Typeset";


const StyledLink = styled.div`
  margin: 10px 0;
  cursor: pointer;
  color: white;
  font-size: 0.8rem;
`;

class ForgotPasswordForm extends React.Component {
  state = {
    email: "",
  };

  handleTextChange = (event, attrName) => {
    const text = event.target.value;
    this.props.onChange(attrName, text);
    this.setState({ [attrName]: text });
  };

  handleSubmit = event => {
    event.preventDefault();
    this.props.handleSubmit(this.state);
  };

  render = () => {
    return (
      <Container maxWidth={'xs'}>
        <div style={{backgroundColor: 'rgba(39, 37, 37, .85)', borderRadius: 8, padding: '30px'}}>
          <H4 style={{textAlign: 'center', marginBottom: 40}}>FORGOT PASSWORD</H4>
          <form onSubmit={this.handleSubmit}>
            <div>
              <div style={{fontSize: '0.8rem', marginBottom: 6}}>Email</div>
              <StyledInput
                type="email"
                value={this.state.email}
                placeholder={'Email'}
                onChange={(e) => this.handleTextChange(e, 'email')}
              />
              {this.props.errors && this.props.errors.email && <StyledError>{this.props.errors.email}</StyledError>}
              {this.props.errors && this.props.errors.non_field_errors && <StyledError>{this.props.errors.non_field_errors}</StyledError>}
            </div>
            <StyledButton type="submit" style={{marginTop: 15}} disabled={!this.state.email}>Submit</StyledButton>
            <div style={{marginTop: 10}}>
              <StyledLink onClick={this.props.onClickLogin}>
                Sign in
              </StyledLink>
            </div>
          </form>
        </div>
      </Container>
    );
  };
}

export default ForgotPasswordForm;
